export const CLINICIAN = 'CLINICIAN';
export const PATIENT = 'PATIENT';

export const userTypes = [
  CLINICIAN,
  PATIENT,
];

export const userTypesMessages = {
  CLINICIAN: { id: 'General.Clinician', defaultMessage: '** Clinician' },
  PATIENT: { id: 'General.Patient', defaultMessage: '** Patient' },
};
